import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  padding: 24px 0 24px 24px;
`;
